if (!customElements.get("release-products")) {
  class ReleaseProducts extends HTMLElement {
    connectedCallback() {
      // Sort synchronously before the browser paints, so the user only ever
      // sees the sorted order. The container starts at opacity:0 via CSS, then
      // we toggle .is-sorted to fade it in.
      this.sortByReleaseTimestamp();
      this.classList.add("is-sorted");
    }

    sortByReleaseTimestamp() {
      const products = Array.from(
        this.querySelectorAll(":scope > [data-release-timestamp]"),
      );
      if (products.length <= 1) return;

      products.sort((a, b) => {
        const aTs = Number(a.dataset.releaseTimestamp) || 0;
        const bTs = Number(b.dataset.releaseTimestamp) || 0;
        return aTs - bTs;
      });

      // appendChild() on an existing child moves it rather than duplicating,
      // so this rearranges in place without losing listeners or state.
      const fragment = document.createDocumentFragment();
      products.forEach((product) => fragment.appendChild(product));
      this.appendChild(fragment);
    }
  }

  customElements.define("release-products", ReleaseProducts);
}

if (!customElements.get("release-product")) {
  class ReleaseProduct extends HTMLElement {
    connectedCallback() {
      this.fetchLatestProductData();
    }

    fetchLatestProductData() {
      const articleUrl = this.dataset.articleUrl;

      if (!articleUrl) return;

      fetch(`${articleUrl}?section_id=release_product`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );

          const releaseProduct = html.querySelector("release-product");
          const releaseProductCard = releaseProduct.querySelector("card-component");

          if(releaseProduct) {
            this.querySelector("card-component").innerHTML = releaseProductCard.innerHTML;

            if(releaseProduct.classList.contains("release-product--sold-out")) {
              this.classList.add("release-product--sold-out");
            }
            else {
              this.classList.remove("release-product--sold-out");
            }
          }
        });
    }
  }

  customElements.define("release-product", ReleaseProduct);
}
